<template>
  <BError
    :error-title="i18n.t('general.error')"
    :error-info="i18n.t('transcription.generationFailed', { resourceName })"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

type TProps = {
  resourceName: string;
};
defineProps<TProps>();

const i18n = useI18n();
</script>
